// extracted by extract-css-chunks-webpack-plugin
module.exports = {"toolbar":"toolbar","info":"info","queue":"queue","loginicon":"loginicon"};